exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".phone__not__found[data-v-7bc966fa] {\n  display: block;\n}\n", ""]);

// exports
